module.exports = __webpack_public_path__ + "img/srp-rows-toyota.38876184.png";